var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"map-editor-layer-header"},[_c('r-icon',{attrs:{"name":_vm.state.modelLayers.length ? 'model-layer' : _vm.getGeomIcon(),"size":14}}),_c('r-text',[_vm._v(" "+_vm._s(_vm.state.name)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }